import Vue from 'vue'
import VueRouter from 'vue-router'
import { isEmpty } from 'lodash';
import qs from 'query-string';
import RouterLinkModified from './RouterLinkModified'
import store from '../store'
import Root from '../views/Root'
import RootWrap from '../views/RootWrap'
import routes from './routes'
import routesRedirect301, {rootRoutes} from './routesRedirect301'
import {setMetaRobots, deleteMetaRobots} from '@/helpers/metaRobots'
import setCanonical from './common/setCanonical'
import setAlternate from './common/setAlternate'
import scrollBehavior from './common/scrollBehavior'
import formatRoutesPaths from './common/formatRoutesPaths'
import checkLang from './common/checkLang'
import checkAuthForRoute from '../helpers/checkAuthForRoute'
import { bindCustomHotjars } from './integrations/customHotjars';
import { sendPageTitleAndDescription } from './common/sendPageData';
import $store from '@/store'
import {MODERATOR, EMPLOYER, EMPLOYEE} from '../constants/usersTypes';


// -- remove double slash --//
// if (window.location.href.match(/\/\//igm)) {
//   const newPath = window.location.pathname.replace(/\/\/+/igm, '/')
//   window.history.replaceState(null, '', newPath + window.location.search)
// }


Vue.use(VueRouter)
Vue.component('RouterLinkModified', RouterLinkModified)


const localesKeys = Object.keys(store.state.locales)

// console.log(formatRoutesPaths(routesRedirect301.concat(routes)))
// console.log(createRootDouble(formatRoutesPaths(routes)))

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    component: RootWrap,
    children: [
      ...rootRoutes,
      {
        path: `/:lang(\\${localesKeys.join('|')})`,
        component: Root,
        children: formatRoutesPaths(routesRedirect301.concat(routes)),
      },
      ...createRootDouble(formatRoutesPaths(routes)),
    ]
  }],
  scrollBehavior
})

router.beforeEach(async (to, from, next) => {
  bindCustomHotjars(to, from);

  const utmMarks = getUtmMarks(to.query);
  if (utmMarks) {
    localStorage.setItem('utm_marks', utmMarks);
  }

  if (store.state.currentLocale !== (to.params.lang || 'ua')) {
    await store.dispatch('resetAll')
  }

  if (store.state.aiToken && !to.query.categories) {
    store.dispatch('sendAlert', {type: 'navigation'})
  } else if (!store.state.aiToken) {
    store.dispatch('ailogin', 'ai login')
  }

  /* ----- */

  // // -- only lowerCase --//
  // if (to.path.toLowerCase() !== to.path) {
  //   return next({path: to.path.toLowerCase(), query: to.query})
  // }

  // // -- remove double slash --//
  // if (to.path.match(/\/\//igm)) {
  //   const newPath = to.path.replace(/\/\/+/igm, '/')
  //   return next({path: newPath, query: to.query})
  // }

  // -- add slash to the end of path --//
  if (!to.path.endsWith('/')) {
    return next({path: to.path + '/', query: to.query})
  }

  // -- redirect default lang --//
  if (to.params.lang && to.params.lang === 'ua') {
    if (!to.name.endsWith('-double')) {
      const newTo = {...to}
      newTo.name = newTo.name + '-double'

      return next(newTo)
    }
  }

  // -- requiredUserTypes --//
  const requiredUserTypes = checkAuthForRoute(to)
  if (requiredUserTypes) {
    return redirectToLogin(requiredUserTypes)
  }

  setCanonical(to)
  setAlternate(to)

  // -- remove meta robots --//
  deleteMetaRobots()

  if (Object.keys(to.query).length) {
    setMetaRobots('noindex, follow')
  }

  const currentRouteLang = to.params.lang
  if ($store.state.localesToClose.includes(currentRouteLang)) {
    setMetaRobots('noindex, follow')
  }

  checkLang(to, from, next)

  function redirectToLogin(requiredUserTypes) {
    // const isUser = store.getters['user/isLogged'] && store.state.user.profile
    // const requiredUserTypeRoute = to.matched.reverse().find(record => {
    //   if (isUser) {
    //     if(!Array.isArray(record.meta.requiredUserTypes)) return false
    //     return record.meta.requiredUserTypes.includes(store.state.user.profile.user_type)
    //   } else {
    //     return Array.isArray(record.meta.requiredUserTypes) && record.meta.requiredUserTypes.length
    //   }
    // })

    if (to.query.confirm_token) {
      return next({
        name: 'auth-employer-double',
        query: {
          redirect: to.fullPath,
        },
      });
    }

    if (
      requiredUserTypes?.length
      && requiredUserTypes.includes(EMPLOYER)
      && !requiredUserTypes.includes(EMPLOYEE)
    ) {
      return next({
        name: 'auth-employer',
        params: { ...to.params },
        query: {
          ...to.query,
          redirect: to.fullPath,
        }
      });
    }

    if (
      requiredUserTypes
      && requiredUserTypes.length === 1
      && requiredUserTypes[0] === MODERATOR
    ) {
      return next({
        name: !to.params.lang ? 'sign-in-moderator-double' : 'sign-in-moderator',
        params: {...to.params},
        query: {
          redirect: to.fullPath,
        }
      })
    }

    return next({
      name: !to.params.lang ? 'auth-double' : 'auth',
      params: {...to.params},
      query: {
        redirect: to.fullPath,
        // user_type: requiredUserTypeRoute ? requiredUserTypeRoute.meta.requiredUserTypes[0] : null
      }
    })
  }

});

router.afterEach((to) => {
  sendPageTitleAndDescription(to);
});

function createRootDouble(routes) {
  return routes.map(route => {
    const newRoute = {
      ...route
    }

    if (!newRoute.path.startsWith('/')) {
      newRoute.path = '/' + newRoute.path
    }

    setName(newRoute)

    return newRoute
  })
}

function setName(route) {
  if (route.name) {
    route.name = route.name + '-double'
  }

  if (Array.isArray(route.children)) {
    route.children = route.children.map(childRoute => {
      const newRoute = {...childRoute}
      return setName(newRoute)
    })
  }

  return route
}

router.push = createPush('push')
router.replace = createPush('replace')

function createPush(method) {
  return function (location, onComplete, onAbort) {
    if (
      this.currentRoute.params.lang === 'ua' ||
      !this.currentRoute.params.lang &&
      typeof location === 'object'
    ) {

      const newLocation = {...location}

      if (!newLocation.params) {
        newLocation.params = {}
      }

      if (newLocation.name && !newLocation.name.endsWith('-double')) {
        newLocation.name = newLocation.name + '-double'
      }

      return router.__proto__[method].call(this, newLocation, onComplete, onAbort)
    }

    return router.__proto__[method].call(this, location, onComplete, onAbort)
  }
}

export function getStoredUtmMarks() {
  const storedMarks = localStorage.getItem('utm_marks');
  return getUtmMarks() || storedMarks;
}

function getUtmMarks(routeQuery) {
  const query = routeQuery || qs.parse(location.search);
  const result = {};

  for (const [key, value] of Object.entries(query)) {
    if (key.startsWith('utm_')) {
      result[key] = value;
    }
  }

  if (isEmpty(result)) return;

  return JSON.stringify(result);
}

export default router
